import { mainColor, UNIT } from '../../constants';

export const styles = () => ({
  root: {
    flexGrow: 1
  },
  table: {},
  button: {
    backgroundColor: mainColor.colorWhite
  },
  progress: {
    margin: UNIT * 5,
    textAlign: 'center',
    color: mainColor.secondaryColor,
    alignSelf: 'center'
  },
  heading: {
    fontSize: UNIT * 0.9375,
    fontWeight: 'bolder',
    color: mainColor.colorBlackLight,
    maxWidth: UNIT * 8.375
  },
  lastHeading: {
    fontSize: UNIT * 0.9375,
    padding: UNIT * 0.5625,
    fontWeight: 'bolder',
    color: mainColor.colorBlackLight
  },
  valueC: {
    fontSize: UNIT * 0.875,
    padding: UNIT * 1.0625,
    flexBasis: '19%',
    flexShrink: 0,
    textAlign: 'center',
    color: 'black !important'
  },
  graph: {
    padding: 20,
    border: 'solid',
    borderRadius: 16,
    borderWidth: 0.8,
    borderColor: mainColor.colorGray
  },
  headingTab: {
    fontSize: UNIT * 0.9375,
    fontWeight: 'bolder',
    color: mainColor.colorBlackLight,
    maxWidth: '211px'
  },
  typo: {
    fontSize: UNIT * 0.75,
    color: '#3E3E3E!important',
  },
  valueStyle: { fontWeight: 'bolder', color: 'black!important' },
  table: {
    width: '100%',
    textAlign: 'center',
  },
  tableCell: {
    textAlign: 'center',
    verticalAlign: 'middle',
  },
  heading: {
    textAlign: 'center',
    verticalAlign: 'middle',
    fontWeight: 'bold',
  },
  tableCellContent: {
    textAlign: 'justify',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    lineHeight: `${UNIT * 0.5}px`,
    gap: '29px'
  },
  black: {
    color: 'black!important'
  },
  orderTypeContainer: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    gap: '8px'
  },
  orderTypeRow: {
    display: 'contents'
  },
  value: {
    textAlign: 'center',
    fontWeight: 'bold'
  },
  label: {
    fontSize: UNIT * 0.75,
    width: 'max-content',
    marginLeft: '-4px'

  }

});
